// Packages
import { v4 as uuidv4 } from "uuid";

export const CLIENT_STATUS_TAG = {
  red: ["offline"],
  green: ["online"],
};

export const CLIENT_TAG_LABEL = {
  offline: "Offline",
  online: "Online",
};

export const uuids = {
  selectedClient: uuidv4(),
  updateClient: uuidv4(),
  statistics: uuidv4(),
}

const endTimestamp = Date.now() / 1000;

export const defaultTrafficData = {
  downLinkStats: [
    { timestamp: endTimestamp, value: 0 },
    { timestamp: endTimestamp - 24 * 60 * 60, value: 0 },
  ],
  upLinkStats: [
    { timestamp: endTimestamp, value: 0 },
    { timestamp: endTimestamp - 24 * 60 * 60, value: 0 },
  ],
}
